<template>
  <div class="generateKey-wrapper">
    <div>
      <el-button type="primary" :loading="isLoading" @click="generateKey()">生成密钥</el-button>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'Index',
  components: {},
  data() {
    return {
      isLoading: false
    }
  },
  mounted() {},
  methods: {
    generateKey() {
      console.log(JSON.parse(localStorage.getItem('cbaas_system_userInfo')).ID)

      this.isLoading = true

      let params = {
        user_id: String(JSON.parse(localStorage.getItem('cbaas_system_userInfo')).ID)
      }

      axios({
        method: 'POST',
        url: '/cbaas-service/v1/paillier/genKeys',
        data: params,
        responseType: 'arraybuffer'
      })
        .then(res => {
          let blob = new Blob([res.data], {
            type: 'application/zip'
          })
          let url = window.URL.createObjectURL(blob)
          const link = document.createElement('a') // 创建a标签
          link.href = url
          link.download = 'PaillierKeys' // 重命名文件
          link.click()
          URL.revokeObjectURL(url) // 释放内存
          // this.$message.success(
          //   `成功...,后续解密私钥数量须和门限数量一致，并且须要连贯的${obj.threshold}个私钥`
          // )
          this.isLoading = false
          /* 下载文件 */
        })
        .catch(err => {
          this.isLoading = false
        })
    }
  }
}
</script>

<style scoped lang="scss">
</style>
